const initialState = {
  list: null,
  entity: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_YEAR_OF_ACTION_RESOURCES":
      return {
        ...state,
        list: action.payload
      };

    case "FETCH_YEAR_OF_ACTION_RESOURCE":
      return {
        ...state,
        entity: action.payload
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/yearOfActionResourceReducer.js